import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import Table, { TableBody, TableHead, HeaderCategory, SortDirection, TableRow, } from '@helsenorge/designsystem-react/components/Table';
import designsystemtypography from '@helsenorge/designsystem-react/scss/typography.module.scss';
import SubContent from './sub-content';
import { createHeaders } from './table-head-helper';
import { sortIndexes, isTableTwoDimensional, createRows, checkChildren, updateColumns } from './table-helper';
import styles from './styles.module.scss';
export class DataTable extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "rowRefs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentDidUpdate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (_prevProps, prevState) => {
                // Fokus på siste rad idet Hent flere-knapp ikke vises lenger
                if (this.props.data?.length &&
                    this.props.showMoreButtonText &&
                    prevState.countShowing !== this.state.countShowing &&
                    this.state.countShowing === this.props.data.length) {
                    const rowKey = `row${this.props.data.length - 1}`;
                    if (Object.prototype.hasOwnProperty.call(this.rowRefs, rowKey)) {
                        this.rowRefs[rowKey].current?.focusOnTrigger();
                    }
                }
            }
        });
        Object.defineProperty(this, "getOrCreateRowRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rowKey) => {
                if (!Object.prototype.hasOwnProperty.call(this.rowRefs, rowKey)) {
                    this.rowRefs[rowKey] = React.createRef();
                }
                return this.rowRefs[rowKey];
            }
        });
        Object.defineProperty(this, "onHeaderClickSortChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (columnKey, sortDir) => {
                if (this.props.sortDisabled) {
                    this.setState({
                        currentSortDir: sortDir,
                        currentSortKey: columnKey,
                    });
                    if (this.props.onSortColumn) {
                        this.props.onSortColumn(columnKey, sortDir === SortDirection.asc, true, true);
                    }
                }
                else {
                    this.onSortChange(columnKey, sortDir, this.state.sortedData ? this.state.sortedData : [], true);
                }
            }
        });
        Object.defineProperty(this, "onSortChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (columnKey, sortDir, data, isClicked) => {
                const sortedData = sortIndexes(columnKey, sortDir, data, this.props.useNumericSort, this.props.customSetSortValue);
                this.setState({
                    sortedData: sortedData,
                    colSortDirs: {
                        [columnKey]: sortDir,
                    },
                    currentSortDir: sortDir,
                    currentSortKey: columnKey,
                    sortedByUserClick: isClicked ? isClicked : false,
                    expandedRows: {},
                }, this.sortStateChanged);
            }
        });
        Object.defineProperty(this, "sortStateChanged", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.props.onSortColumn) {
                    this.props.onSortColumn(this.state.currentSortKey ? this.state.currentSortKey : '', this.state.currentSortDir === SortDirection.asc, this.state.sortedByUserClick, this.props.sortDisabled);
                }
            }
        });
        Object.defineProperty(this, "toggleExpandRow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (expandableRowKey) => {
                const expanded = !!this.state.expandedRows && this.state.expandedRows[expandableRowKey];
                this.setState({ expandedRows: Object.assign({}, this.state.expandedRows, { [expandableRowKey]: !expanded }) });
            }
        });
        Object.defineProperty(this, "updateCountShowing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                if (event) {
                    event.preventDefault();
                }
                if (this.props.data && this.props.showMorePageSize && this.state.countShowing) {
                    const newCountShowing = this.state.countShowing + this.props.showMorePageSize;
                    if (newCountShowing <= this.props.data.length) {
                        this.setState({
                            countShowing: newCountShowing,
                        });
                    }
                    else if (this.state.countShowing < this.props.data.length) {
                        this.setState({
                            countShowing: this.props.data.length,
                        });
                    }
                }
            }
        });
        const { initialSortColumnKey, initialSortDirIsAsc, data, disableTwoDimensional, showMorePageSize } = props;
        const childrenProps = checkChildren(props);
        const colSortDirs = {};
        if (initialSortColumnKey) {
            colSortDirs[initialSortColumnKey] = initialSortDirIsAsc ? SortDirection.asc : SortDirection.desc;
        }
        this.rowRefs = {};
        this.state = {
            unsortedData: data ? data : [],
            sortedData: data ? data : [],
            colSortDirs,
            columns: childrenProps.columns,
            expandableRow: childrenProps.expandableRow,
            sortable: false,
            currentSortDir: undefined,
            currentSortKey: '',
            prevSortDir: undefined,
            prevSortKey: '',
            sortedByUserClick: false,
            expandedRows: {},
            isTwoDimensional: data && !disableTwoDimensional ? isTableTwoDimensional(data, childrenProps.columns) : false,
            countShowing: showMorePageSize,
        };
    }
    componentDidMount() {
        this.setState({ unsortedData: this.props.data });
        if (this.props.initialSortColumnKey && (!this.props.sortDisabled || this.props.doInitialSort) && this.props.data) {
            this.onSortChange(this.props.initialSortColumnKey, this.props.initialSortDirIsAsc ? SortDirection.asc : SortDirection.desc, this.props.data);
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const updatedState = { ...prevState };
        if (nextProps.data !== prevState.unsortedData) {
            updatedState.unsortedData = nextProps.data ? nextProps.data : [];
        }
        if (nextProps.sortDisabled !== !!prevState.sortable) {
            updatedState.sortable = !nextProps.sortDisabled;
        }
        const nextSortColumnKey = nextProps.sortColumnKey ? nextProps.sortColumnKey : prevState.prevSortKey;
        const nextSortColumDir = nextProps.sortDirIsAsc !== null && typeof nextProps.sortDirIsAsc !== 'undefined'
            ? nextProps.sortDirIsAsc
                ? SortDirection.asc
                : SortDirection.desc
            : prevState.prevSortDir;
        // Sammenlikner sortprops med sortstates for å se om det har kommet nye oppdateringer utenfor klassen
        if (!nextProps.sortDisabled &&
            nextSortColumnKey &&
            nextProps.data &&
            nextSortColumDir &&
            (nextSortColumnKey !== prevState.prevSortKey ||
                nextSortColumDir !== prevState.prevSortDir ||
                nextProps.data !== prevState.unsortedData)) {
            // I stor grad samme håndtering som gjøres i onSortChange(), må kopieres nå som vi ikke har "this" her.
            updatedState.sortedData = sortIndexes(nextSortColumnKey, nextSortColumDir, nextProps.data ?? [], nextProps.useNumericSort, nextProps.customSetSortValue);
            updatedState.colSortDirs = {
                [nextSortColumnKey]: nextSortColumDir,
            };
            updatedState.currentSortDir = nextSortColumDir;
            updatedState.currentSortKey = nextSortColumnKey;
            updatedState.prevSortDir = nextSortColumDir;
            updatedState.prevSortKey = nextSortColumnKey;
            updatedState.expandedRows = {};
            if (nextProps.onSortColumn) {
                nextProps.onSortColumn(nextSortColumnKey, nextSortColumDir === SortDirection.asc, true, nextProps.sortDisabled);
            }
        }
        // Hvis vi har ny data, men ikke pga. ny sortering
        else {
            if (nextProps.data !== prevState.unsortedData) {
                const newData = nextProps.data ? nextProps.data : [];
                updatedState.unsortedData = newData;
                updatedState.sortedData = newData;
            }
        }
        const currentColumnCount = prevState.columns ? prevState.columns.length : 0;
        const nextColumnCount = checkChildren(nextProps).columns.length;
        if (currentColumnCount !== nextColumnCount) {
            updatedState.columns = updateColumns(nextProps);
        }
        if (updatedState !== prevState) {
            return updatedState;
        }
        else {
            return null;
        }
    }
    render() {
        const { sortedData, columns, isTwoDimensional, countShowing, colSortDirs, expandableRow, expandedRows } = this.state;
        const { id, caption, error, data, showMorePageSize, showMoreButtonClasses, showMoreButtonText, wrapperClassNames, tableClassNames, breakpointConfig, initialSortColumnKey, sortDisabled, sortColumnKey, rowKeyColumnKey, highlightText, emptyContentText, emptyContentElement, noAnchorLinkWrapper, rowClassNames, mode, } = this.props;
        const rows = sortedData
            ? createRows(id, countShowing ? sortedData.slice(0, countShowing) : sortedData, this.toggleExpandRow, this.getOrCreateRowRef, rowKeyColumnKey, highlightText, emptyContentText, emptyContentElement, columns, isTwoDimensional, expandableRow, expandedRows, rowClassNames)
            : [];
        const wrapperClasses = classnames({
            [`${styles['table']}`]: true,
        }, wrapperClassNames);
        const headers = createHeaders(columns ? columns : [], colSortDirs ? colSortDirs : {}, this.onHeaderClickSortChange, initialSortColumnKey, sortDisabled, sortColumnKey, expandableRow, isTwoDimensional, sortedData);
        const tableClasses = classnames({
            [`${designsystemtypography['anchorlink-wrapper']}`]: !noAnchorLinkWrapper,
        }, tableClassNames);
        const captionId = `${id}-caption`;
        return (_jsxs("div", { className: wrapperClasses, children: [_jsxs(Table, { className: tableClasses, id: id, breakpointConfig: breakpointConfig, mode: mode, scrollAriaLabelledById: captionId, children: [_jsx("caption", { className: `${styles.table__caption}`, id: captionId, children: caption }), _jsx(TableHead, { category: !sortDisabled ? HeaderCategory.sortable : this.props.transparentHeader ? HeaderCategory.transparent : HeaderCategory.normal, children: _jsx(TableRow, { children: headers }, "head") }), !error ? _jsx(TableBody, { children: rows }) : _jsx(_Fragment, {})] }), _jsx(SubContent, { countShowing: countShowing, error: error, data: data, showMorePageSize: showMorePageSize, showMoreButtonText: showMoreButtonText, showMoreButtonClasses: showMoreButtonClasses, updateCountShowing: this.updateCountShowing })] }));
    }
}
Object.defineProperty(DataTable, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        sortDisabled: false,
        caption: 'Dette er en tabell',
        id: 'Table1',
    }
});
